import React, {Component} from 'react';
import Loading from '../../../components/Loading';
import Form from './Form';
import { connect } from 'react-redux';
import {ToastContainer, toast} from 'react-toastify';
import { SubmissionError } from 'redux-form';


import * as pageService from '../../../services/page';

class Page extends Component {

    constructor(props) {

        super(props);

        this.state = {
            data : {buyer:false,crmPage:false,webSitePage:false,seller:false},
            loaded : false
        }

        this.load = this.load.bind(this);
        this.show = this.show.bind(this);
        this.submit = this.submit.bind(this);

    }

    componentWillMount() {
        this.load();
    }


    load() {
        if(this.props.match.params.id) {

            pageService.view(this.props.match.params.id).then((data) => {

                this.setState({
                    data,
                    loaded : true
                });

            });

        }else{
            this.setState({loaded : true});
        }
    }

    show() {

        this.props.history.push(`/page/${this.props.match.params.id}`);

    }

    submit(values) {

        this.setState({loaded: false})

        if (values.contents) values.contents.map((el, index) => {
            el.position = index;
        });
        const edit = (!values.id) ? pageService.create : pageService.update;

        return edit(values).then((data) => {
            this.setState({data});
            this.setState({loaded: true})
            toast.success('Enregistrement réussi');

        }).catch((error) => {

            throw new SubmissionError(error);

        });


    }


    render() {

        const {history, match} = this.props;
        const { data, loading } = this.state;

        return (
            <div className="animated fadeIn">

                {!this.state.loaded && <Loading />}
                {this.state.loaded && <Form onSubmit={this.submit} initialValues={data} show={this.show} />}


            </div>
        )
    }
}

export default Page





// WEBPACK FOOTER //
// ./src/views/Cms/Pages/Page.js